import { TabPaneProps, Tabs } from 'antd';

import React, { FC, useEffect, useMemo, useState } from 'react';

import { useSearchParams } from 'react-router-dom';
import ModuleLoader, {
  ReducesList,
} from 'shared/lib/ModuleLoader/ModuleLoader';
import { setAllVisible } from 'shared/lib/helpers';
import useWindowDimensions from 'shared/lib/hooks/useWindowDimensions';

import { ORDSection } from 'shared/ui';
import { webinarSlice } from '../model/WebinarSlice';

import './WebinarPage.style.less';
import VideoCard from './VideoCard';

interface Tab extends TabPaneProps {
  key: string;
  label: React.ReactNode;
}
const initialReducers: ReducesList = {
  webinar: webinarSlice.reducer,
};

const WebinarsPage: FC = () => {
  const { width } = useWindowDimensions();
  const [urlParams, setUrlParams] = useSearchParams();
  const [tab, setTab] = useState<string>(urlParams.get('tab') || '');
  const webinarsItems: Tab[] = useMemo(
    () => [
      {
        key: 'lessons',
        label: 'Обучающие видео',
        children: <VideoCard videoType="lessons" />,
      },
      {
        key: 'webinars',
        label: 'Вебинары',
        children: <VideoCard videoType="webinars" />,
      },
      {
        key: 'live_streams',
        label: 'Видеотрансляции',
        children: <VideoCard videoType="streams" />,
      },
    ],
    [],
  );
  useEffect(() => {
    setAllVisible();
  }, []);
  useEffect(() => {
    if (tab) {
      urlParams.set('tab', tab);
      setUrlParams(urlParams);
      return;
    }
    urlParams.set('tab', 'lessons');
    setUrlParams(urlParams);
  }, [tab]);
  return (
    <ModuleLoader reducers={initialReducers} removeAfterUnmount>
      <ORDSection
        isH1
        title="Видеоматериалы по работе с ОРД"
        className="webinar"
        description={
          <Tabs
            data-testid="menu"
            defaultActiveKey={tab}
            moreIcon
            tabPosition={width >= 660 ? 'left' : 'top'}
            items={webinarsItems}
            onChange={(key) => {
              setTab(key);
            }}
          />
        }
      />
    </ModuleLoader>
  );
};

export default WebinarsPage;
